import React from 'react'
import help from 'assets/help.svg'

const FormLabel = (props) => (
      <label className="form__label"  htmlFor="{props.id}">{props.name} {props.title ? <span data-tooltip={props.title} className="tooltip-right"><img src={help}  /> </span> : ''}</label>
)

export default FormLabel;


// WEBPACK FOOTER //
// ./src/components/FormLabel.jsx